<script setup>
import { computed } from 'vue'
import { rentalStatusConfig, vehicleStatusConfig } from '@/composables/useRentalStatus.js'

const props = defineProps({
  type: { type: String, required: true }, // 'rental' | 'vehicle'
  status: { type: String, required: true },
  overdue: { type: Boolean, default: false }, // for rental: show overdue instead of active
})

const config = computed(() => {
  if (props.type === 'vehicle') return vehicleStatusConfig[props.status] || vehicleStatusConfig.available
  const effectiveStatus = (props.type === 'rental' && props.overdue && props.status === 'active')
    ? 'overdue'
    : props.status
  return rentalStatusConfig[effectiveStatus] || rentalStatusConfig.pending
})
</script>

<template>
  <!-- Vehicle badge: dot + label, no pill -->
  <span v-if="type === 'vehicle'" class="inline-flex items-center gap-1.5 text-sm font-medium" :class="config.text">
    <span class="w-2 h-2 rounded-full flex-shrink-0" :class="config.dot"></span>
    {{ config.label }}
  </span>

  <!-- Rental badge: filled/outline pill -->
  <span
    v-else
    class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold border"
    :class="[config.bg, config.text, config.border]"
  >
    <!-- Clock icon for pending -->
    <svg v-if="config.icon === 'clock'" class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>
    </svg>
    <!-- Exclamation for overdue -->
    <svg v-if="config.icon === 'exclamation'" class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <path stroke-linecap="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
    </svg>
    <!-- Checkmark for returned -->
    <svg v-if="config.icon === 'check'" class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/>
    </svg>
    <span :class="{ 'line-through': status === 'cancelled' }">{{ config.label }}</span>
  </span>
</template>
